import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import Select from 'react-select';
import _ from "lodash";

import callApi from "../callApi.js";
import { blogCopyInput } from "./data.js";


const AddBlogCopy = () => {
    const navigate = useNavigate();

    const blogCategories = [
        { value: 'about-us', label: 'About Us' },
        { value: 'credit-cards', label: 'Credit Cards' },
        { value: 'discounts', label: 'Discounts' },
        { value: 'personal-finance', label: 'Personal Finance' },
        { value: 'press-release', label: 'Press Release' },
        { value: 'value-of-data', label: 'Value Of Data' },
    ];

    const dataTransformations = (data) => {
        let result = {};
        for (let key in data) {
            if (typeof(data[key]) == "string" && 
                key === 'url_count' &&
                data[key] !== "") {
                    result[key] = parseFloat(data[key]);
            }
            else if(typeof(data[key]) == "string" && data[key] !== "") {
                result[key] = data[key];
            }
            else if(_.isArray(data[key]) && data[key].length > 0) {
                let items = [];
                for (let value of data[key]) {
                    if (typeof(value) == "string" && value !== "") {
                        items.push(value);
                    }
                    else if (typeof(value) == "object") {
                        let object_result = dataTransformations(value);
                        if (!_.isEmpty(object_result)) {
                            items.push(object_result);
                        }
                    }
                }
                if(items.length > 0) {
                    result[key] = items;
                }
            }
            else if(typeof(data[key]) == "object") {
                let object_result = dataTransformations(data[key]);
                if (!_.isEmpty(object_result)) {
                    result[key] = object_result;
                }
            }
            else if(typeof(data[key]) == "boolean") {
                result[key] = data[key];
            }
        }
        return result;
    };

    const saveBlogCopies = (blog_copy, setSubmitting) => {
        let url = `${process.env.REACT_APP_API_URL}/v1/content/blog/aggregated_copy`;
        callApi(url, 'POST', {'blog_copy': blog_copy})
            .then((json) => {
                setSubmitting(false);
                navigate('/blog-copies');
            })
            .catch((err) => err);
    };

    return (
        <div className="index-page">
            <h1 className="title">
                Blog Copy - Input Form
            </h1>
            <Formik
                initialValues={blogCopyInput}
                validate={values => {
                    const isIntegerRegex = /^-?\d*$/;
                    const errors = {};

                    const required_fields = [
                        'article_instructions.topic', 'article_instructions.content_outline', 
                        'article_instructions.table_outline', 'article_instructions.writing_style',
                        'article_instructions.brief', 'article_instructions.applicable_country', 
                        'article_instructions.dobin_context', 'article_instructions.dobin_feature',
                        'article_instructions.primary_keywords', 'article_instructions.secondary_keywords'
                    ];
                    for (let value of required_fields) {
                        if (!_.get(values, value)) {
                            _.set(errors, value, 'Required');
                        }
                    }

                    if (_.get(values, 'reference_article_urls.external')) {
                        for (let value of _.get(values, 'reference_article_urls.external')) {
                            if (value && !value.startsWith('https://')) {
                                _.set(errors, 'reference_article_urls.external', 'Invalid URL');
                            }
                        }
                    }

                    if (_.get(values, 'reference_article_urls.dobin')) {
                        for (let value of _.get(values, 'reference_article_urls.dobin')) {
                            if (value && !value.startsWith('https://')) {
                                _.set(errors, 'reference_article_urls.dobin', 'Invalid URL');
                            }
                        }
                    }

                    if (_.get(values, 'search_instructions.url_count') && 
                        !(isIntegerRegex.test(_.get(values, 'search_instructions.url_count')))) {
                        _.set(errors, 'search_instructions.url_count', 'Must be an integer');
                    }

                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    let blog_copy = dataTransformations(values);
                    saveBlogCopies(blog_copy, setSubmitting);
                }}
            >
                {({ values, isSubmitting, setFieldValue }) => (
                    <Form>
                        <div className="pt-2">
                            <hr className="border-2 border-dark" />                        
                        </div>

                        <h4>
                            Search Instructions
                        </h4>
                        <div className="row mt-40">
                            <label className="col-md-2">URL Count:</label>
                            <Field 
                                className="col-md-8" 
                                type="text" name="search_instructions.url_count" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="search_instructions.url_count" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Brief:</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="search_instructions.brief" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="search_instructions.brief" component="div" />
                        </div>
                        <div className="pt-4">
                            <hr className="border-2 border-dark" />                        
                        </div>

                        <h4>
                            Reference Article URLs
                        </h4>
                        <div className="row mt-40">
                            <label className="col-md-2">External:</label>
                            <FieldArray
                                className="col-md-8"
                                name="reference_article_urls.external"
                                render={arrayHelpers => (
                                <div>
                                    {values.reference_article_urls && 
                                    values.reference_article_urls.external &&
                                    values.reference_article_urls.external.length > 0 ? (
                                    values.reference_article_urls.external.map((r, index) => (
                                        <div key={index}>
                                        <Field className="col-md-6" name={`reference_article_urls.external.${index}`} />
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.remove(index)}
                                        >
                                            -
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.insert(index, '')}
                                        >
                                            +
                                        </button>
                                        </div>
                                    ))
                                    ) : (
                                    <button type="button" onClick={() => arrayHelpers.push('')}>
                                        Add External Reference Article URL
                                    </button>
                                    )}
                                </div>
                                )}
                            />
                            <ErrorMessage 
                                className="text-danger" 
                                name="reference_article_urls.external" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Dobin:</label>
                            <FieldArray
                                className="col-md-8"
                                name="reference_article_urls.dobin"
                                render={arrayHelpers => (
                                <div>
                                    {values.reference_article_urls && 
                                    values.reference_article_urls.dobin &&
                                    values.reference_article_urls.dobin.length > 0 ? (
                                    values.reference_article_urls.dobin.map((r, index) => (
                                        <div key={index}>
                                        <Field className="col-md-6" name={`reference_article_urls.dobin.${index}`} />
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.remove(index)}
                                        >
                                            -
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.insert(index, '')}
                                        >
                                            +
                                        </button>
                                        </div>
                                    ))
                                    ) : (
                                    <button type="button" onClick={() => arrayHelpers.push('')}>
                                        Add Dobin Reference Article URL
                                    </button>
                                    )}
                                </div>
                                )}
                            />
                            <ErrorMessage 
                                className="text-danger" 
                                name="reference_article_urls.dobin" component="div" />
                        </div>
                        <div className="pt-4">
                            <hr className="border-2 border-dark" />                        
                        </div>

                        <h4>
                            SEO References
                        </h4>
                        <div className="row mt-40">
                            <FieldArray
                                className="col-md-8"
                                name="seo_references"
                                render={arrayHelpers => (
                                <div>
                                    {values.seo_references && 
                                    values.seo_references.length > 0 ? (
                                    values.seo_references.map((r, index) => (
                                        <div key={index}>
                                        <Field className="col-md-6" name={`seo_references.${index}`} />
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.remove(index)}
                                        >
                                            -
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.insert(index, '')}
                                        >
                                            +
                                        </button>
                                        </div>
                                    ))
                                    ) : (
                                    <button type="button" onClick={() => arrayHelpers.push('')}>
                                        Add SEO Reference
                                    </button>
                                    )}
                                </div>
                                )}
                            />
                        </div>
                        <div className="pt-4">
                            <hr className="border-2 border-dark" />                        
                        </div>

                        <h4>
                            Article Instructions
                        </h4>
                        <div className="row mt-40">
                            <label className="col-md-2">Topic:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.topic" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.topic" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Content Outline:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.content_outline" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.content_outline" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Table Outline:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.table_outline" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.table_outline" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Writing Style:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.writing_style" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.writing_style" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Brief:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.brief" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.brief" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Dobin Context:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.dobin_context" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.dobin_context" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Dobin Feature:*</label>
                            <Field 
                                className="col-md-8" 
                                as="textarea"
                                type="text" name="article_instructions.dobin_feature" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.dobin_feature" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Applicable Country:*</label>
                            <Field 
                                className="col-md-8"
                                type="text" name="article_instructions.applicable_country" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.applicable_country" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Primary Keywords:*</label>
                            <FieldArray
                                className="col-md-8"
                                name="article_instructions.primary_keywords"
                                render={arrayHelpers => (
                                <div>
                                    {values.article_instructions && 
                                    values.article_instructions.primary_keywords &&
                                    values.article_instructions.primary_keywords.length > 0 ? (
                                    values.article_instructions.primary_keywords.map((r, index) => (
                                        <div key={index}>
                                        <Field className="col-md-6" name={`article_instructions.primary_keywords.${index}`} />
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.remove(index)}
                                        >
                                            -
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.insert(index, '')}
                                        >
                                            +
                                        </button>
                                        </div>
                                    ))
                                    ) : (
                                    <button type="button" onClick={() => arrayHelpers.push('')}>
                                        Add Primary Keywords
                                    </button>
                                    )}
                                </div>
                                )}
                            />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.primary_keywords" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Secondary Keywords:*</label>
                            <FieldArray
                                className="col-md-8"
                                name="article_instructions.secondary_keywords"
                                render={arrayHelpers => (
                                <div>
                                    {values.article_instructions && 
                                    values.article_instructions.secondary_keywords &&
                                    values.article_instructions.secondary_keywords.length > 0 ? (
                                    values.article_instructions.secondary_keywords.map((r, index) => (
                                        <div key={index}>
                                        <Field className="col-md-6" name={`article_instructions.secondary_keywords.${index}`} />
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.remove(index)}
                                        >
                                            -
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => arrayHelpers.insert(index, '')}
                                        >
                                            +
                                        </button>
                                        </div>
                                    ))
                                    ) : (
                                    <button type="button" onClick={() => arrayHelpers.push('')}>
                                        Add Secondary Keywords
                                    </button>
                                    )}
                                </div>
                                )}
                            />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_instructions.secondary_keywords" component="div" />
                        </div>
                        <div className="pt-4">
                            <hr className="border-2 border-dark" />                        
                        </div>

                        <h4>
                            Article Details
                        </h4>
                        <div className="row mt-40">
                            <label className="col-md-2">Domain:*</label>
                            <Field 
                                className="col-md-8" 
                                type="text" name="article_details.domain" />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_details.domain" component="div" />
                        </div>
                        <div className="row mt-40">
                            <label className="col-md-2">Category:</label>
                            <Select
                                className="col-md-8"
                                name="blog_category"
                                options={blogCategories}
                                onChange={(selected) => setFieldValue("article_details.category", selected.value)} />
                            <ErrorMessage 
                                className="text-danger" 
                                name="article_details.category" component="div" />
                        </div>

                        <div className="index-container">
                            <button 
                                className="index-button"
                                type="submit" disabled={isSubmitting}>
                                    Aggregate
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};


export default AddBlogCopy;